module.exports = __webpack_public_path__ + "img/id-card-icon.dfd7b69a.svg";